import React from 'react';

import { Login } from 'presentation/pages';

export const MakeLoginFactory: React.FC = () => {
  return <Login />;
};
